import UserApi from './UserApi';
import GisApi from './GisApi';
import MetaApi from './MetaApi';
import AnnouncementApi from './Announcement';
import ClaimApi from './ClaimApi';
import Complex from './Complex';
import Article from './Article';
import AgencyApi from './Agency';
import DomainsApi from './DomainsApi';
import TariffsApi from './Tariffs';
import ConfigApi from './ConfigApi';

export default function ({ apiPrefix, gisPrefix } = {}) {
  if (!apiPrefix || !gisPrefix) {
    throw new Error('apiPrefix and gisPrefix is required');
  }

  return {
    article: new Article({ prefix: apiPrefix }),
    announcement: new AnnouncementApi({ prefix: apiPrefix }),
    claim: new ClaimApi({ prefix: apiPrefix }),
    user: new UserApi({ prefix: apiPrefix }),
    gis: new GisApi({ prefix: gisPrefix }),
    complex: new Complex({ prefix: apiPrefix }),
    meta: new MetaApi({ prefix: apiPrefix }),
    agency: new AgencyApi({ prefix: apiPrefix }),
    domains: new DomainsApi({ prefix: apiPrefix }),
    tariffs: new TariffsApi({ prefix: apiPrefix }),
    config: new ConfigApi({ prefix: apiPrefix })
  };
}



// WEBPACK FOOTER //
// ./src/api/index.js